import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
// import routesNew from './routersOrg'
import store from '@/store'
import iView from 'iview'
import { setToken, getToken, canTurnTo, setTitle, localRead, localSave, localDel } from '@/libs/util'
import config from '@/config'
import { loadMenu } from './router-list'
// import { menusList } from '@/api/menus/menu'
const { homeName } = config

Vue.use(Router)
// 点击当前菜单不会报错
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
let newRouters = [...routes, ...loadMenu()]
// console.log(123123)
// console.log(newRouters)
const router = new Router({
  // routes,
  // 2023-03-08
  routes: newRouters,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'
const turnTo = (to, access, next) => {
  // console.log(11111)
  // console.log(newRouters)
  if (canTurnTo(to.name, access, newRouters)) next() // 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()
  // console.log('in.......')
  // 存缓存
  const menu = localRead('route') // 读取路由数据 2023-03-08
  // console.log('缓存...' + menu)
  if (menu === '' || menu === 'undefined') {
    // menusList().then(res => {
    //   var menuData = res.data
    //   localSave('route', JSON.stringify(menuData))
    // })
    localSave('route', JSON.stringify([]))
  }
  newRouters = [...routes, ...loadMenu()]
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    if (to.name === 'error_404' || to.name === 'error_401' || to.name === 'error_500') {
      next()
    } else {
      next({
        name: LOGIN_PAGE_NAME
      })
    }
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next()
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    })
  } else {
    if (store.state.user.hasGetInfo) {
      turnTo(to, store.state.user.access, next, newRouters)
    } else {
      store.dispatch('getUserInfo').then(user => {
        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
        turnTo(to, user.access, next, newRouters)
      }).catch(() => {
        setToken('')
        localDel('route')
        next({
          name: LOGIN_PAGE_NAME
        })
      })
    }
  }
})

router.afterEach(to => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
